import React from 'react';

/**
 * Payment-method card from the "Metodos de pago" section.
 * Surface-gray rounded card with a bold title and a smaller description.
 *
 *   <PaymentMethodCard
 *     title="Transferencia banco - banco"
 *     description="Transferí desde tu banco, ..."
 *   />
 */
export default function PaymentMethodCard({ title, description }) {
  return (
    <div className='flex w-full flex-col rounded-lg bg-surface px-4 py-4'>
      <p className='font-sans text-sm font-medium text-ink leading-snug'>{title}</p>
      <p className='mt-2.5 font-sans text-[10px] font-light text-ink leading-snug'>{description}</p>
    </div>
  );
}
